import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import footerData from 'core/data/footer.json';
import { useInitialFetch } from 'core/context/initialFetchContext';
import { FaTiktok } from "react-icons/fa";

const Footer_v1 = () => {
	const [data, setData] = useState(null);
	const { storeInformation } = useInitialFetch();

	useEffect(() => {
		setData(footerData);
	}, []);

	if (!data) {
		return null;
	}

	return (
		<footer className="ltn__footer-area">
			<div className="footer-top-area footer-bg section-bg-2 plr--5  pb-3" style={{ padding: '50px 70px' }} >
				<div className="container-fluid">
					<div className="row d-flex justify-content-center">
						<div className="col-xl-3 col-md-6 col-sm-6 col-12">
							<div className="footer-widget footer-about-widget mb-0">
								<div className="footer-logo">
									<div className="site-logo">
										{/* <SVGComponent url="/assets/img/logo.svg" className="footer logo" style={{ width: '160px' }} onLoad={() => { }} /> */}
									</div>
								</div>
								<div className="footer-address list-unstyled">
									<h4 className="footer-title">Contáctanos</h4>
									<ul>
										{storeInformation?.ruc?.includes('|') && (
											<li className="mt-0">
												<div className="footer-address-icon">
													<i className="fas fa-id-card" />
												</div>
												<div className="footer-address-info">
													<p>
														{storeInformation.ruc.includes('|') ? (
															storeInformation.ruc.split('|')[0]
														) : (
															storeInformation.ruc
														)}
													</p>
												</div>
											</li>
										)}
										{storeInformation?.ruc?.includes('|') && (
											<li className="mt-0">
												<div className="footer-address-icon">
													<i className="fas fa-id-card-alt" />
												</div>
												<div className="footer-address-info">
													<p>{storeInformation.ruc.split('|')[1]}</p>
												</div>
											</li>
										)}
										{storeInformation?.phone_number && (
											<li className="mt-0">
												<div className="footer-address-icon">
													<i className="fas fa-phone" />
												</div>
												<div className="footer-address-info">
													<p>
														{storeInformation.phone_number.includes('|') ? (
															storeInformation.phone_number.split('|')[0]
														) : (
															storeInformation.phone_number
														)}
													</p>
												</div>
											</li>
										 )}
										{storeInformation?.phone_number?.includes('|') && (
											<li className="mt-0">
												<div className="footer-address-icon">
													<i className="fas fa-phone" />
												</div>
												<div className="footer-address-info">
													<p>
														{storeInformation.phone_number.includes('|') ? (
															storeInformation.phone_number.split('|')[1]
														) : (
															storeInformation.phone_number
														)}
													</p>
												</div>
											</li>
										 )}
										 {storeInformation?.phone_number?.includes('|') && (
											<li className="mt-0">
												<div className="footer-address-icon">
													<i className="fas fa-envelope" />
												</div>
												<div className="footer-address-info">
													<p>
														{storeInformation.phone_number.includes('|') ? (
															storeInformation.phone_number.split('|')[2]
														) : (
															storeInformation.phone_number
														)}
													</p>
												</div>
											</li>
										 )}
									</ul>
								</div>
								<div className="footer-social-media">
									<ul className="list-unstyled d-flex gap-3">
										{storeInformation?.instagram && (
											<li><a href={storeInformation.instagram} target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
										)}
										{storeInformation?.twitter && (
											<li><a href={storeInformation.twitter} target="_blank" rel="noopener noreferrer"><FaTiktok size={19} color="white" /></a></li>
										)}
										{storeInformation?.facebook && (
											<li><a href={storeInformation.facebook}  style={{ fontSize: '30px !important' }} target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"  style={{ fontSize: '40px !important' }}></i></a></li>
										)}
										{storeInformation?.whatsapp && (
											<li><a href={`https://wa.me/${storeInformation.whatsapp}`} target="_blank" rel="noopener noreferrer"><i className="fab fa-whatsapp"></i></a></li>
										)}
									</ul>
								</div>
							</div>
						</div>
						<div className="col-xl-2 col-md-6 col-sm-6 col-12 mt-3 mt-md-0">
							<div className="footer-widget footer-menu-widget clearfix mb-0">
								<h4 className="footer-title">{data.company.title}</h4>
								<div className="footer-menu go-top">
									<ul>
										{data.company.links.map((link, index) => (
											<li key={index}><Link to={link.url}>{link.text}</Link></li>
										))}
									</ul>
								</div>
							</div>
						</div>
						<div className="col-xl-2 col-md-6 col-sm-6 col-12">
							<div className="footer-widget footer-menu-widget clearfix mb-0">
								<h4 className="footer-title">{data.services.title}</h4>
								<div className="footer-menu go-top">
									<ul>
										{data.services.links.map((link, index) => (
											<li key={index}><Link to={link.url}>{link.text}</Link></li>
										))}
									</ul>
								</div>
							</div>
						</div>
						<div className="col-xl-2 col-md-6 col-sm-6 col-12">
							<div className="footer-widget footer-menu-widget clearfix mb-0">
								<h4 className="footer-title">{data.customerCare.title}</h4>
								<div className="footer-menu go-top">
									<ul>
										{data.customerCare.links.map((link, index) => (
											<li key={index}><Link to={link.url}>{link.text}</Link></li>
										))}
									</ul>
								</div>
							</div>
						</div>
						<div className="col-xl-9 col-md-6 col-sm-6 col-12">
							<ul className="list-unstyled">
								{storeInformation?.address && (
									<li className="d-flex align-items-start">
										<div className="footer-address-icon">
											<i className="fas fa-map-marker-alt me-2" />
										</div>
										<div className="footer-address-info">
											<p className="mb-0">{storeInformation.address}</p>
										</div>
									</li>
								)}
							</ul>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
}

export default Footer_v1;